import {FlexPage} from '@hconnect/common/components'
import {Box, Stack} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  kilnMonitoringSlot: React.ReactNode
  workOrdersSummarySlot: React.ReactNode
  plantStatusKpisSlot: React.ReactNode
  operationHoursSlot: React.ReactNode
  rcfaSlot: React.ReactNode
  myTasksSlot: React.ReactNode
  downtimeByCategorySlot: React.ReactNode
  isLarge: boolean
}

export const PlantDashboardDesktopLayout: React.FC<LayoutProps> = ({
  titleSlot,
  aboveTitleSlot,
  kilnMonitoringSlot,
  workOrdersSummarySlot,
  plantStatusKpisSlot,
  operationHoursSlot,
  rcfaSlot,
  myTasksSlot,
  downtimeByCategorySlot,
  isLarge
}) => {
  if (isLarge) {
    return (
      <FlexPage
        title={titleSlot}
        aboveTitle={aboveTitleSlot}
        nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
      >
        <Stack direction="row" spacing={2} flexGrow={1} useFlexGap flexWrap="wrap">
          <Stack spacing={2} flex={1} useFlexGap>
            {plantStatusKpisSlot}
            <Stack direction="row" spacing={2}>
              <Box flex={2}>{operationHoursSlot}</Box>
              <Box flex={1}>{workOrdersSummarySlot}</Box>
            </Stack>
            <Stack direction="row" spacing={2} useFlexGap>
              <Box flex={1}>{downtimeByCategorySlot}</Box>
            </Stack>
          </Stack>
          <Stack spacing={2} useFlexGap>
            {kilnMonitoringSlot}
            <Stack spacing={2}>
              {rcfaSlot}
              {myTasksSlot}
            </Stack>
          </Stack>
        </Stack>
      </FlexPage>
    )
  }

  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
    >
      <Stack direction="row" spacing={2} flexGrow={1} useFlexGap flexWrap="wrap">
        <Stack spacing={2} flex={1} useFlexGap>
          {plantStatusKpisSlot}
          <Stack direction="column" spacing={2} flex={1} useFlexGap>
            {kilnMonitoringSlot}
            {operationHoursSlot}
          </Stack>
        </Stack>
        <Stack spacing={2} flex={1} direction="row" useFlexGap>
          <Box flex={1}>{downtimeByCategorySlot}</Box>
        </Stack>
        <Stack spacing={2} flex={1} direction="row" useFlexGap>
          <Box sx={{display: 'flex', flex: '1 0 0'}}>{workOrdersSummarySlot}</Box>
          <Stack spacing={2} flex={1} useFlexGap flexWrap="wrap">
            <Box sx={{display: 'flex', flex: '1 0 0'}}>{rcfaSlot}</Box>
            <Box sx={{display: 'flex', flex: '1 0 0'}}>{myTasksSlot}</Box>
          </Stack>
        </Stack>
      </Stack>
    </FlexPage>
  )
}
